import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import ArrowUpward from "@store/Components/Icons/ArrowUpward";
import { COLORS, COMMON } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import Color from "color";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

const enum fields {
    buttonText = "buttonText",
    arrowBtn = "arrowBtn",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.buttonText]: string;
        [fields.arrowBtn]: boolean;
    };
}

export interface BackToTopButtonStyles {
    backToTopBtn?: ButtonPresentationProps;
}

export const backToTopButtonStyles: BackToTopButtonStyles = {
    backToTopBtn: {
        variant: "secondary",
        css: css`
            border-color: transparent;
            background: ${Color(COLORS.secondary.base).alpha(0.8).string()};

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["8px", null, null, null, "8px 20px"], properties: ["padding"] }],
                    mediaOptions.min,
                )}

            &.smallBtn {
                padding: 8px;
            }
        `,
    },
};

const styles = backToTopButtonStyles;

const BackToTopButton: FC<OwnProps> = ({ fields }) => {
    const { buttonText, arrowBtn } = fields;
    const [currentWidth, setCurrentWidth] = useState(0);

    const handleResize = () => {
        setCurrentWidth(window.innerWidth);
    };

    useEffect(() => {
        setCurrentWidth(window.innerWidth);
        window.addEventListener("resize", handleResize, true);
    }, []);

    const backToTopClickHandler = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <Button {...styles.backToTopBtn} onClick={backToTopClickHandler} className={arrowBtn ? "smallBtn" : ""}>
            {arrowBtn || currentWidth < COMMON.breakpoints[4] ? <ButtonIcon src={ArrowUpward} /> : buttonText}
        </Button>
    );
};

const widgetModule: WidgetModule = {
    component: BackToTopButton,
    definition: {
        group: "Basic",
        displayName: "Back to Top Button",
        icon: "rectangle-wide",
        fieldDefinitions: [
            {
                name: fields.buttonText,
                displayName: "Button Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Back to top",
                isRequired: true,
            },
            {
                name: fields.arrowBtn,
                displayName: "Show button as arrow (no text)",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
